//MUI Imports
import type { Theme } from '@mui/material/styles'

//Type Imports
import type { Skin } from '@core/types'

const dialog = (skin: Skin): Theme['components'] => ({
  MuiDialog: {
    styleOverrides: {
      // A dialog fading OUT (exit-animation sweep, Luca 2026-07-24) must not
      // swallow clicks: its full-screen modal root would otherwise intercept
      // the pointer for the ~200ms of the fade.
      root: ({ ownerState }) => ({
        ...(ownerState.open === false ? { pointerEvents: 'none' } : {})
      }),
      paper: ({ theme }) => ({
        borderRadius: 'var(--mui-shape-customBorderRadius-lg)',
        ...(skin !== 'bordered'
          ? {
              boxShadow: 'var(--mui-customShadows-lg)'
            }
          : {
              boxShadow: 'none'
            }),

        // Mobile (#134): sotto sm i margini stringono a 8px e i tetti di MUI
        // (calc(100% - 64px)) si allargano di conseguenza — i dialog recuperano
        // ~48px in larghezza e ~48px in altezza (footer sopra la piega), quasi
        // un fullScreen ma senza toccare i singoli dialog.
        [theme.breakpoints.down('sm')]: {
          '&:not(.MuiDialog-paperFullScreen)': {
            margin: theme.spacing(2),
            maxWidth: `calc(100% - ${theme.spacing(4)})`,
            maxHeight: `calc(100% - ${theme.spacing(4)})`,
            '&.MuiDialog-paperFullWidth': {
              width: `calc(100% - ${theme.spacing(4)})`
            }
          }
        }
      }),
      paperFullScreen: {
        borderRadius: 0
      }
    }
  },
  MuiDialogTitle: {
    defaultProps: {
      variant: 'h5'
    },
    styleOverrides: {
      root: ({ theme }) => ({
        padding: theme.spacing(6),
        '& + .MuiDialogActions-root': {
          paddingTop: 0
        }
      })
    }
  },
  MuiDialogContent: {
    styleOverrides: {
      root: ({ theme }) => ({
        padding: theme.spacing(6),
        '& + .MuiDialogContent-root, & + .MuiDialogActions-root': {
          paddingTop: 0
        }
      })
    }
  },
  MuiDialogActions: {
    styleOverrides: {
      root: ({ theme }) => ({
        padding: theme.spacing(6),
        '& .MuiButtonBase-root:not(:first-of-type)': {
          marginInlineStart: theme.spacing(4)
        },
        '&:where(.dialog-actions-dense)': {
          padding: theme.spacing(3),
          '& .MuiButton-text': {
            paddingInline: theme.spacing(3)
          }
        }
      })
    }
  }
})

export default dialog
